'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitRegisterForCatalog = exports.registerForCatalogSuccess = exports.registerForCatalogRequest = exports.registerForCatalogFail = exports.getUserRegisterForCatalog = exports.getUserCatalogIdForRegistration = exports.REGISTER_FOR_CATALOG_SUCCESS = exports.REGISTER_FOR_CATALOG_REQUEST = exports.REGISTER_FOR_CATALOG_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = require('../modules/modal');

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('../modules/user');

var _config = require('../modules/config');

var _analytics = require('../modules/analytics');

var _biddable = require('../modules/biddable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var REGISTER_FOR_CATALOG_FAIL = exports.REGISTER_FOR_CATALOG_FAIL = 'la/ui/registerForCatalog/FAIL';
var REGISTER_FOR_CATALOG_REQUEST = exports.REGISTER_FOR_CATALOG_REQUEST = 'la/ui/registerForCatalog/REQUEST';
var REGISTER_FOR_CATALOG_SUCCESS = exports.REGISTER_FOR_CATALOG_SUCCESS = 'la/ui/registerForCatalog/SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    catalogId: null,
    error: false,
    fromBiddingConsole: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.OPEN_REGISTER_FOR_CATALOG_MODAL:
            return (0, _extends3.default)({}, state, {
                catalogId: action.payload.catalogId,
                fromBiddingConsole: action.payload.fromBiddingConsole ? action.payload.fromBiddingConsole : false
            });
        case REGISTER_FOR_CATALOG_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case REGISTER_FOR_CATALOG_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case REGISTER_FOR_CATALOG_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var registerForCatalogSelector = function registerForCatalogSelector(state) {
    return state.user.registerForCatalog;
};

var getUserCatalogIdForRegistration = exports.getUserCatalogIdForRegistration = (0, _reselect.createSelector)(registerForCatalogSelector, function (catalogRegistrations) {
    return catalogRegistrations.catalogId;
});

var getUserRegisterForCatalog = exports.getUserRegisterForCatalog = (0, _reselect.createSelector)(registerForCatalogSelector, function (catalogRegistrations) {
    return catalogRegistrations;
});

/* ACTION CREATORS */
var registerForCatalogFail = exports.registerForCatalogFail = function registerForCatalogFail(catalogId, error) {
    return {
        error: true,
        meta: { catalogId: catalogId },
        payload: error,
        type: REGISTER_FOR_CATALOG_FAIL
    };
};

var registerForCatalogRequest = exports.registerForCatalogRequest = function registerForCatalogRequest(catalogId) {
    return {
        payload: catalogId,
        type: REGISTER_FOR_CATALOG_REQUEST
    };
};

var registerForCatalogSuccess = exports.registerForCatalogSuccess = function registerForCatalogSuccess(catalogId, analytics) {
    return {
        meta: analytics,
        payload: catalogId,
        type: REGISTER_FOR_CATALOG_SUCCESS
    };
};

var submitRegisterForCatalog = exports.submitRegisterForCatalog = function submitRegisterForCatalog(catalogId, preventAddCreditCardModal) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(registerForCatalogRequest(catalogId));
        return _api.Catalog.postRegisterForCatalog({ authToken: authToken, catalogId: catalogId, deployment: deployment }).then(function (response) {
            var analytics = (0, _analytics.getRequestedAuctionRegistrationAnalytics)(state, catalogId);
            if (response.success) {
                dispatch(registerForCatalogSuccess(catalogId, analytics));
                dispatch((0, _modal.closeModalAndCheckCreditCard)(preventAddCreditCardModal));
            } else {
                dispatch(registerForCatalogFail(catalogId, response.message));
            }
        }).then(function () {
            dispatch((0, _biddable.openBiddableModal)(catalogId));
        }).catch(function (error) {
            dispatch(registerForCatalogFail(catalogId, error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/registerForCatalog.js
// module id = eUWk
// module chunks = 57